import { atom } from "recoil";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export interface CompanyTabCriteria {
  companyName: string;
  organizationName: string;
}

export interface OrgTabCriteria {
  companyName: string;
  parentCompanyName: string;
}

export interface JobTabCriteria {
  parentCompanyId: string;
  companyId: string;
  title: string;
}

export interface TabSearchState<T> {
  criteria: T;
  page: number;
  pageSize: number;
  hasSearched: boolean;
}

export interface CompanyManagementSearchState {
  companyTab: TabSearchState<CompanyTabCriteria>;
  orgTab: TabSearchState<OrgTabCriteria>;
  jobTab: TabSearchState<JobTabCriteria>;
}

export const defaultCompanyManagementSearchState: CompanyManagementSearchState = {
  companyTab: {
    criteria: { companyName: "", organizationName: "" },
    page: 0,
    pageSize: 25,
    hasSearched: false,
  },
  orgTab: {
    criteria: { companyName: "", parentCompanyName: "" },
    page: 0,
    pageSize: 25,
    hasSearched: false,
  },
  jobTab: {
    criteria: { parentCompanyId: "", companyId: "", title: "" },
    page: 0,
    pageSize: 25,
    hasSearched: false,
  },
};

export const companyManagementSearchAtom = atom<CompanyManagementSearchState>({
  key: RecoilKeys.CompanyManagementSearch,
  default: defaultCompanyManagementSearchState,
});
